export default {
    company: null
}
  